// Centralised site content (static, SEO-oriented French copy) for FuiteX

export const CONTACT = {
  brand: "FuiteX",
  slogan: "Voir l'invisible. Trouver l'essentiel.",
  signature: "Localisation précise. Intervention rapide.",
  activity: "Recherche de fuite d'eau non destructive",
  zone: "Toute l'Île-de-France",
  phoneDisplay: "01 86 95 84 88",
  phoneTel: "+33186958488",
  email: "contact@fuitex.fr",
  hours: "Lun–Sam · 8h–20h · Urgences 7j/7",
};

export const NAV = [
  { label: "Accueil", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Méthodes", to: "/methodes" },
  { label: "Pourquoi FuiteX", to: "/pourquoi-fuitex" },
  { label: "Zone d'intervention", to: "/zone-intervention" },
  { label: "Réalisations", to: "/realisations" },
  { label: "FAQ", to: "/faq" },
  { label: "Blog", to: "/blog" },
];

export const AUDIENCES = [
  { icon: "Home", title: "Particuliers", text: "Maison, appartement, piscine — une fuite localisée sans casser." },
  { icon: "Building2", title: "Syndics & gestionnaires", text: "Copropriétés et parties communes : diagnostic clair et rapide." },
  { icon: "HardHat", title: "Professionnels du bâtiment", text: "Un partenaire de confiance avant, pendant et après vos travaux." },
  { icon: "ShieldCheck", title: "Assurances & experts", text: "Compte-rendu détaillé pour vos dossiers de dégât des eaux." },
];

export const SERVICES = [
  {
    slug: "canalisation-encastree",
    num: "01",
    icon: "Waves",
    title: "Fuite sur canalisation encastrée",
    keyword: "recherche de fuite canalisation encastrée",
    text: "Une canalisation encastrée qui fuit dans un mur ou une dalle peut faire des dégâts invisibles pendant des semaines. Grâce au détecteur acoustique et à la caméra thermique, nous localisons le point exact de la fuite au centimètre près, sans ouvrir vos murs à l'aveugle.",
  },
  {
    slug: "piscine",
    num: "02",
    icon: "Droplets",
    title: "Recherche de fuite de piscine",
    keyword: "recherche de fuite piscine",
    text: "Niveau d'eau qui baisse anormalement ? Nous identifions si la fuite provient du bassin, des canalisations, des skimmers ou du système de filtration, à l'aide de tests de pression et de colorants traceurs adaptés.",
  },
  {
    slug: "chauffage-au-sol",
    num: "03",
    icon: "ThermometerSun",
    title: "Fuite sur chauffage au sol",
    keyword: "recherche de fuite chauffage au sol",
    text: "Une fuite sur un plancher chauffant fait chuter la pression du circuit. Nous localisons précisément le tube défectueux par caméra thermique et gaz traceur, pour une réparation ciblée sans détruire toute la chape.",
  },
  {
    slug: "degat-des-eaux-assurance",
    num: "04",
    icon: "FileCheck2",
    title: "Recherche pour dossier d'assurance",
    keyword: "recherche de fuite dégât des eaux assurance",
    text: "En cas de dégât des eaux, notre recherche de fuite et notre compte-rendu détaillé, illustré de photos, facilitent la constitution et l'indemnisation de votre dossier auprès de votre assurance.",
  },
  {
    slug: "copropriete-syndic",
    num: "05",
    icon: "Building2",
    title: "Copropriétés & syndics",
    keyword: "recherche de fuite copropriété",
    text: "Fuites en parties communes, colonnes, sous-sols ou entre étages : nous intervenons pour les syndics et gestionnaires avec méthode, discrétion et un rapport exploitable pour les copropriétaires.",
  },
  {
    slug: "avant-travaux",
    num: "06",
    icon: "Hammer",
    title: "Recherche avant travaux",
    keyword: "recherche de fuite avant travaux",
    text: "Avant une rénovation, un contrôle non destructif permet d'anticiper les points faibles du réseau d'eau et d'éviter les mauvaises surprises une fois le chantier lancé.",
  },
];

export const METHODS = [
  {
    num: "01",
    icon: "ThermometerSun",
    title: "Caméra thermique",
    text: "L'imagerie thermique révèle les écarts de température provoqués par l'humidité et l'eau qui circule. Elle met en évidence le trajet d'une fuite derrière un mur ou sous une dalle, sans aucune destruction.",
  },
  {
    num: "02",
    icon: "AudioLines",
    title: "Détecteur acoustique",
    text: "Un capteur ultra-sensible amplifie le bruit caractéristique de l'eau sous pression qui s'échappe d'une canalisation. En quadrillant la zone, nous remontons jusqu'au point précis de la fuite.",
  },
  {
    num: "03",
    icon: "Gauge",
    title: "Testeur d'humidité",
    text: "L'hygromètre confirme la présence et la concentration d'eau dans les matériaux (plâtre, béton, bois). Il permet de délimiter la zone touchée avant toute intervention.",
  },
  {
    num: "04",
    icon: "ScanSearch",
    title: "Caméra d'inspection",
    text: "Une caméra endoscopique explore visuellement l'intérieur des canalisations et des gaines pour contrôler raccords, fissures et obstructions, là où l'œil ne peut pas aller.",
  },
  {
    num: "05",
    icon: "Wind",
    title: "Gaz traceur",
    text: "Un mélange gazeux inerte est injecté dans le réseau : il remonte par le point de fuite et est détecté en surface par un renifleur électronique. Idéal pour les micro-fuites indétectables autrement.",
  },
];

export const WHY = [
  { icon: "Crosshair", title: "Localisation précise, sans casse inutile", text: "Nous trouvons la fuite avant de toucher quoi que ce soit. Résultat : des réparations ciblées et une facture maîtrisée." },
  { icon: "Zap", title: "Intervention rapide, même en urgence", text: "Nous savons qu'un dégât des eaux n'attend pas. Nous nous organisons pour intervenir dans les meilleurs délais en Île-de-France." },
  { icon: "Cpu", title: "Matériel professionnel de dernière génération", text: "Caméras thermiques, détecteurs acoustiques, gaz traceur : un équipement complet pour chaque situation." },
  { icon: "FileText", title: "Compte-rendu détaillé remis après intervention", text: "Photos, localisation, méthode utilisée : un rapport clair, utile pour vos travaux comme pour votre assurance." },
  { icon: "ShieldCheck", title: "Une entreprise assurée et de confiance", text: "Transparence sur les tarifs, proximité et respect de vos locaux : la relation client est au cœur de notre métier." },
];

export const VALUES = [
  { title: "Précision", text: "Chaque intervention vise le point exact de la fuite, au centimètre." },
  { title: "Rapidité", text: "Une organisation pensée pour l'urgence et le stress du dégât des eaux." },
  { title: "Transparence", text: "Des tarifs clairs et un compte-rendu honnête après chaque mission." },
  { title: "Proximité", text: "Une entreprise à taille humaine, à l'écoute partout en Île-de-France." },
];

export const DEPARTMENTS = [
  { slug: "paris-75", name: "Paris", code: "75", cities: ["Paris 1er", "Paris 2e", "Paris 3e", "Paris 4e", "Paris 5e", "Paris 6e", "Paris 7e", "Paris 8e", "Paris 9e", "Paris 10e", "Paris 11e", "Paris 12e", "Paris 13e", "Paris 14e", "Paris 15e", "Paris 16e", "Paris 17e", "Paris 18e", "Paris 19e", "Paris 20e"], keyword: "recherche de fuite d'eau Paris" },
  { slug: "seine-et-marne-77", name: "Seine-et-Marne", code: "77", cities: ["Meaux", "Melun", "Chelles", "Fontainebleau", "Pontault-Combault", "Savigny-le-Temple", "Villeparisis", "Torcy", "Champs-sur-Marne", "Roissy-en-Brie", "Combs-la-Ville", "Dammarie-les-Lys", "Provins", "Coulommiers", "Lagny-sur-Marne", "Nemours", "Ozoir-la-Ferrière", "Bussy-Saint-Georges", "Mitry-Mory", "Le Mée-sur-Seine"], keyword: "recherche de fuite d'eau Seine-et-Marne" },
  { slug: "yvelines-78", name: "Yvelines", code: "78", cities: ["Versailles", "Saint-Germain-en-Laye", "Mantes-la-Jolie", "Poissy", "Sartrouville", "Conflans-Sainte-Honorine", "Les Mureaux", "Trappes", "Montigny-le-Bretonneux", "Houilles", "Chatou", "Plaisir", "Rambouillet", "Élancourt", "Guyancourt", "Vélizy-Villacoublay", "Le Chesnay-Rocquencourt", "Maisons-Laffitte", "Achères", "Carrières-sous-Poissy"], keyword: "recherche de fuite d'eau Yvelines" },
  { slug: "essonne-91", name: "Essonne", code: "91", cities: ["Évry-Courcouronnes", "Massy", "Palaiseau", "Étampes", "Corbeil-Essonnes", "Savigny-sur-Orge", "Sainte-Geneviève-des-Bois", "Viry-Châtillon", "Athis-Mons", "Draveil", "Grigny", "Yerres", "Brétigny-sur-Orge", "Les Ulis", "Ris-Orangis", "Longjumeau", "Montgeron", "Vigneux-sur-Seine", "Juvisy-sur-Orge", "Villebon-sur-Yvette"], keyword: "recherche de fuite d'eau Essonne" },
  { slug: "hauts-de-seine-92", name: "Hauts-de-Seine", code: "92", cities: ["Boulogne-Billancourt", "Nanterre", "Neuilly-sur-Seine", "Courbevoie", "Colombes", "Asnières-sur-Seine", "Rueil-Malmaison", "Levallois-Perret", "Issy-les-Moulineaux", "Antony", "Clamart", "Meudon", "Clichy", "Suresnes", "Châtenay-Malabry", "Gennevilliers", "Montrouge", "Puteaux", "Bagneux", "Malakoff"], keyword: "recherche de fuite d'eau Hauts-de-Seine" },
  { slug: "seine-saint-denis-93", name: "Seine-Saint-Denis", code: "93", cities: ["Saint-Denis", "Montreuil", "Aubervilliers", "Aulnay-sous-Bois", "Drancy", "Noisy-le-Grand", "Bondy", "Bobigny", "Épinay-sur-Seine", "Pantin", "Le Blanc-Mesnil", "Sevran", "La Courneuve", "Rosny-sous-Bois", "Neuilly-sur-Marne", "Gagny", "Villepinte", "Stains", "Bagnolet", "Livry-Gargan"], keyword: "recherche de fuite d'eau Seine-Saint-Denis" },
  { slug: "val-de-marne-94", name: "Val-de-Marne", code: "94", cities: ["Créteil", "Vitry-sur-Seine", "Champigny-sur-Marne", "Vincennes", "Saint-Maur-des-Fossés", "Maisons-Alfort", "Ivry-sur-Seine", "Villejuif", "Fontenay-sous-Bois", "Alfortville", "Choisy-le-Roi", "Le Perreux-sur-Marne", "Cachan", "Nogent-sur-Marne", "Villeneuve-Saint-Georges", "L'Haÿ-les-Roses", "Charenton-le-Pont", "Thiais", "Fresnes", "Bry-sur-Marne"], keyword: "recherche de fuite d'eau Val-de-Marne" },
  { slug: "val-doise-95", name: "Val-d'Oise", code: "95", cities: ["Cergy", "Argenteuil", "Sarcelles", "Pontoise", "Franconville", "Ermont", "Garges-lès-Gonesse", "Goussainville", "Bezons", "Taverny", "Gonesse", "Villiers-le-Bel", "Sannois", "Eaubonne", "Herblay-sur-Seine", "Saint-Ouen-l'Aumône", "Deuil-la-Barre", "Montmorency", "Osny", "Domont"], keyword: "recherche de fuite d'eau Val-d'Oise" },
];

export const TESTIMONIALS = [
  { name: "Sophie M.", role: "Particulier — Paris 15e", rating: 5, text: "Fuite invisible dans la salle de bain. FuiteX l'a localisée en une heure sans casser mes carreaux. Rapport nickel pour l'assurance." },
  { name: "Cabinet Duval", role: "Syndic — Boulogne (92)", rating: 5, text: "Une fuite en sous-sol nous rendait fous depuis des mois. Diagnostic clair, intervention propre. Nous les recommandons à tous nos immeubles." },
  { name: "Karim B.", role: "Particulier — Créteil (94)", rating: 5, text: "Ma facture d'eau avait triplé. Ils ont trouvé une fuite sur canalisation enterrée. Professionnels et honnêtes sur le prix." },
  { name: "Piscines Léman", role: "Pro du bâtiment — Yvelines (78)", rating: 5, text: "Nous faisons appel à FuiteX pour toutes nos recherches de fuite de bassin. Précision et réactivité au rendez-vous." },
];

export const REALISATIONS = [
  {
    title: "Fuite encastrée en cuisine — Paris 11e",
    context: "Tache d'humidité récurrente au bas d'un mur porteur.",
    method: "Caméra thermique + détecteur acoustique",
    result: "Fuite localisée sur un raccord encastré, ouverture ciblée de 20 cm au lieu de démolir le mur.",
    before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    image: "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    title: "Perte d'eau piscine — Yvelines",
    context: "Baisse de 3 cm par jour sur un bassin de 50 m³.",
    method: "Test de pression réseau + colorant traceur",
    result: "Fuite identifiée sur la canalisation de refoulement, réparation sans vidange complète du bassin.",
    before: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    image: "https://images.unsplash.com/photo-1727579674528-600120447183?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    title: "Plancher chauffant — Hauts-de-Seine",
    context: "Chute de pression répétée sur le circuit de chauffage.",
    method: "Gaz traceur + caméra thermique",
    result: "Tube percé localisé sous 4 m² de chape, réparation ciblée sans casser toute la pièce.",
    before: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    image: "https://images.unsplash.com/photo-1527066236128-2ff79f7b9705?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const FAQ = [
  { q: "Comment savoir si j'ai une fuite d'eau ?", a: "Plusieurs signes doivent alerter : une facture d'eau anormalement élevée, une tache d'humidité ou de moisissure sur un mur, un compteur qui tourne alors que tout est fermé, un bruit d'écoulement continu ou une baisse de pression. Au moindre doute, une recherche de fuite non destructive confirme rapidement l'origine du problème." },
  { q: "La recherche de fuite est-elle vraiment non destructive ?", a: "Oui. Nos méthodes (caméra thermique, détection acoustique, gaz traceur, caméra d'inspection) permettent de localiser la fuite sans démolition. Nous n'ouvrons que le point précis identifié, si une réparation est nécessaire — ce qui réduit fortement les dégâts et le coût des travaux." },
  { q: "Combien coûte une recherche de fuite d'eau ?", a: "Le prix dépend du type de fuite, de la surface à investiguer et des méthodes nécessaires. Nous établissons un devis clair et gratuit avant toute intervention, sans surprise. Contactez-nous pour une estimation adaptée à votre situation." },
  { q: "La recherche de fuite est-elle prise en charge par l'assurance ?", a: "Dans le cadre d'un dégât des eaux, la recherche de fuite est très souvent prise en charge par l'assurance habitation (convention IRSI). Notre compte-rendu détaillé avec photos facilite l'ouverture et l'indemnisation de votre dossier." },
  { q: "Combien de temps dure une intervention ?", a: "La plupart des recherches de fuite sont réalisées en une seule intervention, généralement entre 1 et 3 heures selon la complexité. Vous repartez avec une localisation précise et un compte-rendu." },
  { q: "Intervenez-vous en urgence ?", a: "Oui, nous nous organisons pour intervenir rapidement en cas d'urgence partout en Île-de-France. Appelez-nous : nous privilégions toujours les situations de dégât des eaux actif." },
];

export const ARTICLES = [
  {
    slug: "fuite-eau-invisible-signes",
    title: "Comment savoir si vous avez une fuite d'eau invisible ?",
    keyword: "fuite d'eau invisible signes",
    excerpt: "Facture qui grimpe, humidité, bruit d'écoulement… Voici les signes qui trahissent une fuite d'eau invisible et ce qu'il faut faire.",
    date: "2026-08-12",
    category: "Conseils",
    image: "https://images.unsplash.com/photo-1527066236128-2ff79f7b9705?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Une fuite d'eau invisible peut passer inaperçue pendant des mois tout en dégradant votre logement et en gonflant vos factures. Savoir la repérer tôt permet d'éviter des dégâts coûteux.",
      "Le premier signe est souvent une facture d'eau qui augmente sans raison apparente. Si votre consommation grimpe alors que vos habitudes n'ont pas changé, une fuite est probable.",
      "Surveillez également les taches d'humidité, les auréoles ou les cloques de peinture sur les murs et plafonds, ainsi que les odeurs de moisi. Un bruit d'écoulement continu, même faible, ou un compteur d'eau qui tourne toutes vannes fermées sont des indices déterminants.",
      "Pour lever le doute, coupez tous les points d'eau puis relevez votre compteur : s'il continue de tourner, l'eau part quelque part. Une recherche de fuite non destructive permet alors de localiser précisément l'origine sans casser vos murs.",
    ],
  },
  {
    slug: "facture-eau-qui-augmente",
    title: "Facture d'eau anormalement élevée : et si c'était une fuite ?",
    keyword: "facture d'eau qui augmente sans raison",
    excerpt: "Une hausse soudaine de votre facture d'eau cache souvent une fuite. Comment le vérifier et réagir avant que la note ne s'alourdisse.",
    date: "2026-08-20",
    category: "Conseils",
    image: "https://images.unsplash.com/photo-1585421514738-01798e348b17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Recevoir une facture d'eau bien plus élevée que d'habitude est déstabilisant. Avant de penser à une erreur de relevé, il faut envisager la fuite : c'est la cause la plus fréquente.",
      "Une chasse d'eau qui fuit peut gaspiller plusieurs centaines de litres par jour, et une fuite sur canalisation enterrée peut représenter des mètres cubes perdus sans que vous ne voyiez rien.",
      "Le test du compteur reste le plus simple : notez l'index le soir, ne consommez pas d'eau durant la nuit, et relevez au matin. Toute variation signale une fuite.",
      "Bonne nouvelle : la réglementation protège les particuliers contre les surconsommations liées à une fuite après compteur, sous conditions. Une localisation rapide par un professionnel vous permet de réparer et de constituer votre dossier auprès du service des eaux.",
    ],
  },
  {
    slug: "prix-recherche-de-fuite",
    title: "Recherche de fuite d'eau : combien ça coûte en 2026 ?",
    keyword: "prix recherche de fuite d'eau",
    excerpt: "Quel budget prévoir pour une recherche de fuite non destructive ? Les facteurs de prix et ce qui peut être pris en charge.",
    date: "2026-09-02",
    category: "Prix",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Le prix d'une recherche de fuite d'eau dépend de plusieurs facteurs : le type de fuite, la surface à investiguer, l'accessibilité et les méthodes techniques nécessaires (caméra thermique, acoustique, gaz traceur).",
      "Une recherche simple sur un logement accessible sera plus abordable qu'une investigation complexe sur une canalisation enterrée ou un plancher chauffant nécessitant plusieurs technologies.",
      "L'intérêt de la méthode non destructive est double : elle évite des travaux de démolition coûteux et elle cible la réparation. Le surcoût de la recherche est très largement compensé par les économies réalisées sur les travaux.",
      "Enfin, dans le cadre d'un dégât des eaux, la recherche de fuite est fréquemment prise en charge par l'assurance. Demandez toujours un devis gratuit et détaillé avant l'intervention.",
    ],
  },
  {
    slug: "recherche-fuite-remboursee-assurance",
    title: "Recherche de fuite et assurance : comment se faire rembourser ?",
    keyword: "recherche de fuite remboursée assurance",
    excerpt: "Dégât des eaux, convention IRSI, compte-rendu… Le guide pour faire prendre en charge votre recherche de fuite par l'assurance.",
    date: "2026-09-15",
    category: "Assurance",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "En cas de dégât des eaux, la recherche de fuite est souvent prise en charge par l'assurance habitation. Depuis la convention IRSI, les modalités de prise en charge sont encadrées selon le montant des dommages.",
      "La première étape consiste à déclarer le sinistre à votre assureur dans les délais prévus par votre contrat, généralement cinq jours ouvrés.",
      "Un compte-rendu de recherche de fuite clair, illustré de photos et précisant la méthode employée et la localisation exacte, est déterminant pour l'indemnisation. C'est précisément ce que nous remettons après chaque intervention.",
      "Conservez toutes les factures et échanges. Un dossier bien constitué accélère l'indemnisation et limite les litiges avec votre assurance.",
    ],
  },
  {
    slug: "tache-humidite-mur",
    title: "Tache d'humidité sur un mur : causes et solutions",
    keyword: "tache d'humidité sur mur que faire",
    excerpt: "D'où vient cette tache d'humidité et faut-il s'inquiéter ? Les causes possibles et comment agir efficacement.",
    date: "2026-10-01",
    category: "Conseils",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Une tache d'humidité sur un mur n'est jamais anodine. Elle peut provenir d'une infiltration extérieure, d'une remontée capillaire, d'une condensation excessive ou, très souvent, d'une fuite de canalisation encastrée.",
      "Pour distinguer ces causes, on observe la localisation, la forme et l'évolution de la tache. Une fuite de canalisation produit généralement une auréole qui s'étend et réapparaît même après séchage.",
      "Repeindre par-dessus ne règle rien : sans traiter l'origine, le problème revient et s'aggrave, avec un risque de moisissures nocives pour la santé.",
      "Une recherche de fuite non destructive permet d'identifier la source exacte de l'humidité pour intervenir au bon endroit, une seule fois.",
    ],
  },
  {
    slug: "destructive-vs-non-destructive",
    title: "Recherche de fuite destructive vs non destructive : les différences",
    keyword: "recherche de fuite non destructive",
    excerpt: "Casser pour trouver, ou trouver sans casser ? Comparaison des deux approches et pourquoi la méthode non destructive s'impose.",
    date: "2026-10-18",
    category: "Méthodes",
    image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "La recherche de fuite destructive consiste à ouvrir murs, sols ou dalles pour trouver la fuite « à vue ». Elle est invasive, longue et génère des travaux de remise en état importants.",
      "La recherche non destructive, à l'inverse, utilise des technologies (caméra thermique, détection acoustique, gaz traceur, endoscopie) pour localiser la fuite sans casser, puis ne cible que le point précis à réparer.",
      "L'avantage est évident : moins de dégâts, un chantier plus rapide, un coût global réduit et une remise en état minimale.",
      "C'est pourquoi la méthode non destructive est aujourd'hui la référence, et le cœur du savoir-faire de FuiteX : voir l'invisible, trouver l'essentiel, sans tout démolir.",
    ],
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
export const getDepartment = (slug) => DEPARTMENTS.find((d) => d.slug === slug);
